<template>
  <v-row class="ma-0">
    <v-progress-linear indeterminate color="black" />
  </v-row>
</template>

<script>
  export default {
    name: 'Loading'
  };
</script>

<style></style>
